/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatchedProviderBookingRequestWriteDetail } from '../models/PatchedProviderBookingRequestWriteDetail';
import type { ProviderBookingRequestWriteDetail } from '../models/ProviderBookingRequestWriteDetail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingRequestsUpdateService {

    /**
     * This is a workaround to facilitate a straight forward update of field values on the booking request
     * @returns ProviderBookingRequestWriteDetail
     * @throws ApiError
     */
    public static bookingRequestsUpdateUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: ProviderBookingRequestWriteDetail,
    }): CancelablePromise<ProviderBookingRequestWriteDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/booking-requests-update/{request_id}/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * This is a workaround to facilitate a straight forward update of field values on the booking request
     * @returns ProviderBookingRequestWriteDetail
     * @throws ApiError
     */
    public static bookingRequestsUpdatePartialUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: PatchedProviderBookingRequestWriteDetail,
    }): CancelablePromise<ProviderBookingRequestWriteDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/booking-requests-update/{request_id}/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
